import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Phone } from 'lucide-react';
import { products, companyInfo } from '../../mock/mockData';
import { navigation, aboutSubpages, productIconMap } from './navData';

export const MobileMenu = ({ isActive, onClose }) => {
  const [productsOpen, setProductsOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <div className="lg:hidden pb-4">
      <div className="flex flex-col space-y-1">
        {navigation.map((item) => {
          if (item.hasDropdown) {
            const isAbout = item.hasDropdown === 'about';
            const items = isAbout ? aboutSubpages : products;
            const basePath = isAbout ? '/haqqimizda' : '/mehsullar';
            const open = isAbout ? aboutOpen : productsOpen;
            const setOpen = isAbout ? setAboutOpen : setProductsOpen;
            return (
              <div key={item.name}>
                <button
                  type="button"
                  onClick={() => setOpen(!open)}
                  className={`w-full flex items-center justify-between rounded-lg px-4 py-3 text-base font-medium transition-colors ${
                    isActive(item.href)
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  {item.name}
                  <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
                </button>
                {open && (
                  <div className="ml-4 mt-1 space-y-1 border-l-2 border-blue-100 pl-3">
                    {items.map((entry) => {
                      const Icon = isAbout ? entry.icon : productIconMap[entry.icon];
                      return (
                        <Link
                          key={entry.slug}
                          to={`${basePath}/${entry.slug}`}
                          onClick={() => { onClose(); setOpen(false); }}
                          className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700"
                        >
                          <Icon className="h-4 w-4 text-blue-700" />
                          {entry.title}
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }
          return (
            <Link
              key={item.name}
              to={item.href}
              onClick={onClose}
              className={`rounded-lg px-4 py-3 text-base font-medium transition-colors ${
                isActive(item.href)
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              {item.name}
            </Link>
          );
        })}
        <div className="border-t pt-3 mt-2">
          <a href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`} className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700">
            <Phone className="h-4 w-4 text-blue-600" />
            <span>{companyInfo.phones[0]}</span>
          </a>
        </div>
      </div>
    </div>
  );
};
